var CouponLeaguesRetriever = /** @class */ (function () {
    function CouponLeaguesRetriever(bffGateway, dataProvider, loadedData) {
        this.bff = bffGateway;
        this.dataProvider = dataProvider;
        this.loadedData = loadedData;
        this.requestCouponLeagues = {};
        this.requestCouponLeagues.ids = this.dataProvider.leagueIds;
    }
    /* istanbul ignore next */
    CouponLeaguesRetriever.prototype.setRegionIds = function (regionId) {
        // Not implemented
    };
    /* istanbul ignore next */
    CouponLeaguesRetriever.prototype.removeRegionId = function () {
        // Not implemented
    };
    CouponLeaguesRetriever.prototype.loadData = function () {
        var _this = this;
        this.bff.getLeaguesByLeagueId(this.requestCouponLeagues)
            .then(function (response) { return _this.loadDataSuccessCb(response); })
            .catch(function (err) { console["log"](err); });
    };
    CouponLeaguesRetriever.prototype.loadDataSuccessCb = function (response) {
        if (response.leagues && response.leagues.length) {
            this.loadedData(response.leagues);
        }
    };
    return CouponLeaguesRetriever;
}());
export { CouponLeaguesRetriever };
//# sourceMappingURL=CouponLeaguesRetriever.js.map